import { t } from "@superset-ui/core";

import seoul_11 from "./data/11_seoul.geojson";
import enpyeong_11120 from "./data/11120_enpyeong.geojson";
import yangcheon_11150 from "./data/11150_yangcheon.geojson";

import busan_21 from "./data/21_busan.geojson";
import dongrae_21060 from "./data/21060_dongrae.geojson";

import daegu_22 from "./data/22_daegu.geojson";
import dalseong_22310 from "./data/22310_dalseong.geojson";

import incheon_23 from "./data/23_incheon.geojson";
import ganghwa_23310 from "./data/23310_ganghwa.geojson";

import gwangju_24 from "./data/24_gwangju.geojson";
import daejeon_25 from "./data/25_daejeon.geojson";

import ulsan_26 from "./data/26_ulsan.geojson";
import ulsanjunggu_26010 from "./data/26010_ulsan_jung.geojson";
import ulsanbukgu_26040 from "./data/26040_ulsan_buk.geojson";
import ulsanulju_26310 from "./data/26310_ulju.geojson";

import gyeonggi_31 from "./data/31_gyeonggi.geojson";
import pyeongtaek_31070 from "./data/31070_pyeongtaek.geojson";
import gwacheon_31110 from "./data/31110_gwacheon.geojson";
import yeoju_31280 from "./data/31280_yeoju.geojson";

import gangwon_32 from "./data/32_gangwon.geojson";

import chungcheongbuk_33 from "./data/33_chungcheongbuk.geojson";
import jecheong_33030 from "./data/33030_jecheon.geojson";
import jincheong_33350 from "./data/33350_jincheon.geojson";
import emseong_33370 from "./data/33370_emseong.geojson";

import chungcheongnam_34 from "./data/34_chungcheongnam.geojson";
import gyeryong_34070 from "./data/34070_gyeryong.geojson";
import gongju_34020 from "./data/34020_gongju.geojson";
import asan_34040 from "./data/34040_asan.geojson";
import buyeo_34330 from "./data/34330_buyeo.geojson";

import jeollabuk_35 from "./data/35_jeollabuk.geojson";
import gimje_35060 from "./data/35060_gimje.geojson";

import jeollanam_36 from "./data/36_jeollanam.geojson";
import mokpo_36010 from "./data/36010_mokpo.geojson";
import haenam_36400 from "./data/36400_haenam.geojson";
import gurye_36330 from "./data/36330_gurye.geojson";

import gyeongsangbuk_37 from "./data/37_gyeongsangbuk.geojson";
import pohang_3701 from "./data/3701_pohang.geojson";
import pohangnam_37011 from "./data/37011_pohang_nam.geojson";
import pohangbuk_37012 from "./data/37012_pohang_buk.geojson";
import gimcheon_37030 from "./data/37030_gimcheon.geojson";
import gumi_37050 from "./data/37050_gumi.geojson";
import yeongcheon_37070 from "./data/37070_yeongcheon.geojson";

import gyeongsangnam_38 from "./data/38_gyeongsangnam.geojson";
import geoje_38090 from "./data/38090_geoje.geojson";
import milyang_38030 from "./data/38030_milyang.geojson";
import yangsan_38100 from "./data/38100_yangsan.geojson";
import haman_38320 from "./data/38320_haman.geojson";
import changnyeong_38330 from "./data/38330_changnyeong.geojson";
import hadong_38360 from "./data/38360_hadong.geojson";

import jeju_39 from "./data/39_jeju.geojson";
import jejusi_39010 from "./data/39010_jejusi.geojson";

/** 경상남도 48 */

import {
    busanList,
    chungcheongbukdoList,
    chungcheongnamdoList,
    daeguList,
    daejeonList,
    gangwondoList,
    gwangjuList,
    gyeonggidoList,
    gyeongsangbukdoList,
    gyeongsangnamdoList,
    incheonList,
    jejudoList,
    jeollabukdoList,
    jeollanamdoList,
    regionList,
    seoulList,
} from "./constant";

type regionType = {
    code: number;
    en_name: string;
};

function getRegionLabel(region: regionType) {
    return [region.code, t(region.en_name)];
}

export const mapData: Record<string, any> = {
    seoul_11,
    busan_21,
    daegu_22,
    incheon_23,
    gwangju_24,
    daejeon_25,
    ulsan_26,
    gyeonggi_31,
    gangwon_32,
    chungcheongbuk_33,
    chungcheongnam_34,
    jeollabuk_35,
    jeollanam_36,
    gyeongsangbuk_37,
    gyeongsangnam_38,
    jeju_39,
};

export const koreaOptions = regionList.map(getRegionLabel);

export const seoulOptions = seoulList.map(getRegionLabel);

export const seoulData = {
    seoul_11,
    enpyeong_11120,
    yangcheon_11150,
};

export const busanOptions = busanList.map(getRegionLabel);

export const busanData = {
    busan_21,
    dongrae_21060,
};

export const daeguOptions = daeguList.map(getRegionLabel);

export const daeguData = {
    daegu_22,
    dalseong_22310,
};

export const incheonOptions = incheonList.map(getRegionLabel);

export const incheonData = {
    incheon_23,
    ganghwa_23310,
};

export const gwangjuOptions = gwangjuList.map(getRegionLabel);

export const gwangjuData = {
    gwangju_24,
};

export const daejeongOptions = daejeonList.map(getRegionLabel);

export const daejeongData = {
    daejeon_25,
};

export const ulsanOptions = daejeonList.map(getRegionLabel);

export const ulsanData = {
    ulsan_26,
    ulsanjunggu_26010,
    ulsanbukgu_26040,
    ulsanulju_26310,
};

export const gyeonggidoOptions = gyeonggidoList.map(getRegionLabel);

export const gyeonggiData = {
    gyeonggi_31,
    yeoju_31280,
    gwacheon_31110,
    pyeongtaek_31070,
};

export const gangwondoOptions = gangwondoList.map(getRegionLabel);

export const gangwonData = {
    gangwon_32,
};

export const chungcheongbukOptions = chungcheongbukdoList.map(getRegionLabel);

export const chungcheongbukData = {
    chungcheongbuk_33,
    jecheong_33030,
    jincheong_33350,
    emseong_33370,
};

export const chungcheongnamdoOptions = chungcheongnamdoList.map(getRegionLabel);

export const chungcheongnamData = {
    chungcheongnam_34,
    gongju_34020,
    asan_34040,
    buyeo_34330,
    gyeryong_34070,
};

export const jeollabukdoOptions = jeollabukdoList.map(getRegionLabel);

export const jeollabukData = {
    jeollabuk_35,
    gimje_35060,
};

export const jeollanamdoOptions = jeollanamdoList.map(getRegionLabel);

export const jeollanamData = {
    jeollanam_36,
    mokpo_36010,
    haenam_36400,
    gurye_36330,
};

export const gyeongsangbukdoOptions = gyeongsangbukdoList.map(getRegionLabel);

export const gyeongsangbukData = {
    gyeongsangbuk_37,
    pohang_3701,
    pohangnam_37011,
    pohangbuk_37012,
    gimcheon_37030,
    gumi_37050,
    yeongcheon_37070,
};

export const gyeongsangnamdoOptions = gyeongsangnamdoList.map(getRegionLabel);
export const gyeongsangnamData = {
    gyeongsangnam_38,
    geoje_38090,
    hadong_38360,
    milyang_38030,
    yangsan_38100,
    haman_38320,
    changnyeong_38330,
};

export const jejuOptions = jejudoList.map(getRegionLabel);

export const jejuData = {
    jeju_39,
    jejusi_39010,
};

export const optionCollection = [
    { code: 11, name: "seoul", options: seoulOptions },
    { code: 21, name: "busan", options: busanOptions },
    { code: 22, name: "daegu", options: daeguOptions },
    { code: 23, name: "incheon", options: incheonOptions },
    { code: 24, name: "gwangju", options: gwangjuOptions },
    { code: 25, name: "daejeon", options: daejeongOptions },
    { code: 26, name: "ulsan", options: ulsanOptions },
    { code: 31, name: "gyeonggi", options: gyeonggidoOptions },
    { code: 32, name: "gangwon", options: gangwondoOptions },
    { code: 33, name: "chungcheongbuk", options: chungcheongbukOptions },
    { code: 34, name: "chungcheongnam", options: chungcheongnamdoOptions },
    { code: 35, name: "jeollabuk", options: jeollabukdoOptions },
    { code: 36, name: "jeollanam", options: jeollanamdoOptions },
    { code: 37, name: "gyeongsangbuk", options: gyeongsangbukdoOptions },
    { code: 38, name: "gyeongsangnam", options: gyeongsangnamdoOptions },
    { code: 39, name: "jeju", options: jejuOptions },
];

export const fetchGeojsonData = (url: string) =>
    fetch(url)
        .then(async (res) => {
            const resJson = await res.json();
            return resJson;
        })
        .catch((err) => {
            console.log("err", err);
            return undefined;
        });

export const findAreaMap = async (code: number) => {
    let result = "";
    let data = mapData;

    const codeStr = code.toString().slice(0, 2);

    switch (parseInt(codeStr, 10)) {
        case 11:
            data = seoulData;
            break;
        case 21:
            data = busanData;
            break;
        case 22:
            data = daeguData;
            break;
        case 23:
            data = incheonData;
            break;
        case 24:
            data = gwangjuData;
            break;
        case 25:
            data = daejeongData;
            break;
        case 26:
            data = ulsanData;
            break;
        case 31:
            data = gyeonggiData;
            break;
        case 32:
            data = gangwonData;
            break;
        case 33:
            data = chungcheongbukData;
            break;
        case 34:
            data = chungcheongnamData;
            break;
        case 35:
            data = jeollabukData;
            break;
        case 36:
            data = jeollanamData;
            break;
        case 37:
            data = gyeongsangbukData;
            break;
        case 38:
            data = gyeongsangnamData;
            break;
        case 39:
            data = jejuData;
            break;
        default:
            data = mapData;
    }

    Object.keys(data).forEach((key) => {
        if (Number(key.split("_")[1]) === code) {
            result = data[key];
        }
    });

    return fetchGeojsonData(result);
};
